var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1403 0.928955H11.1245C5.45174 0.928955 0.852745 5.52796 0.852745 11.1999V25.2166C0.852745 30.8893 5.45094 35.4875 11.1245 35.4875H25.1403C30.8131 35.4875 35.4121 30.8893 35.4121 25.2166V11.1999C35.4121 5.52796 30.8131 0.928955 25.1403 0.928955ZM32.0404 25.0629C32.0404 28.9591 28.8821 32.1174 24.9859 32.1174H11.2797C7.3835 32.1174 4.22518 28.9591 4.22518 25.0629V11.3551C4.22518 7.45892 7.3835 4.3006 11.2797 4.3006H24.9859C28.8821 4.3006 32.0404 7.45892 32.0404 11.3551V25.0629Z",
    fill: "#0047AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3683 9.54419C13.7248 9.54419 9.9472 13.3218 9.9472 17.9645C9.9472 22.6081 13.7256 26.3857 18.3683 26.3857C23.0111 26.3857 26.7887 22.6081 26.7887 17.9645C26.7895 13.3226 23.0111 9.54419 18.3683 9.54419ZM18.3683 23.3595C15.3939 23.3595 12.9734 20.9398 12.9734 17.9645C12.9734 14.9901 15.3939 12.5704 18.3683 12.5704C21.342 12.5704 23.7625 14.9901 23.7625 17.9645C23.7625 20.9398 21.3428 23.3595 18.3683 23.3595Z",
    fill: "#0047AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2801 6.97339C26.173 6.97339 25.2751 7.87122 25.2751 8.97838C25.2751 10.0855 26.173 10.9834 27.2801 10.9834C28.3873 10.9834 29.2851 10.0855 29.2851 8.97838C29.2851 7.87122 28.3873 6.97339 27.2801 6.97339Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.95ad4a825155027cfc2a16a5187ca156.svg";
export { ForwardRef as ReactComponent };